import { render, staticRenderFns } from "./GroupBreakdown.vue?vue&type=template&id=66dd15ce&"
import script from "./GroupBreakdown.vue?vue&type=script&lang=js&"
export * from "./GroupBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./GroupBreakdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports